/**
 * @name delay
 * @description An utility function to add a sleep like function with promise
 * @param {number} timeout - The time to wait
 * @returns {Promise}
 */
export const delay = (timeout: number) =>
  new Promise(resolve => setTimeout(() => resolve(), timeout));

/**
 * @name delayPromise
 * @description Add a custom delay to a promise. For exemple, you want a request
 * makes minimum 500ms but the server respond in less than 500ms, so you can use this
 * @param {Promise} promise - The promise
 * @param {number} timeout - The delay to apply
 * @returns {Promise}
 */

export const delayPromise = <T>(
  promise: Promise<T>,
  timeout: number,
): Promise<T> => {
  const time = Date.now();

  return promise.then(data => {
    const restToTime = Date.now() - time;
    if (restToTime >= timeout) return data;

    return delay(timeout - restToTime).then(() => data);
  });
};
